import { defineComponent as _defineComponent } from 'vue'
import {ref, watch, nextTick, onMounted, onUnmounted, computed} from 'vue';
import {storeToRefs} from 'pinia';
import tim from '../../../components/player/comp-message/tim';
import {useChatStore} from '../../../stores/chat';
import MessageText from './MessageTypes/MessageText.vue';
import mutations from '@/stores/mutations';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageList',
  setup(__props) {

const chatStore = useChatStore();
const {messageList} = storeToRefs(chatStore);
const messageBottomEl = ref<HTMLInputElement | null>(null);
// 为了解决自己向上滚动浏览消息, 防止别人发的消息不停向下滚消息列表
let isScrollNotAtBottom = false;




function getScrollTop() {
  const dom = document.getElementById("messageBottomEls");
	dom.scrollTop = dom.scrollHeight
  
};


const handleMessageListScroll = (e: Event) => {
  const messageContainer = e.target as HTMLElement;
  const bottom = messageContainer.scrollHeight - messageContainer.scrollTop - messageContainer.clientHeight;
  if (bottom > 80) {
    // 30 为判断是否向上滚动浏览消息的阈值
    isScrollNotAtBottom = true;
  } else {
    isScrollNotAtBottom = false;
  }
};


function timestampToTime(timestamp) {
  if (timestamp === 0 || timestamp == null) {
    return ''
  } else {
    var date = new Date(timestamp * 1000)
    var H = date.getHours() + ':'
    var M2 = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    return H + M2
  }
};

watch(messageList, async (newMessageList, oldMessageList) => { // eslint-disable-line
  await nextTick(()=>{
     messageBottomEl.value.scrollTop = messageBottomEl.value.scrollHeight;
  });
 
  //消息列表渲染所需数据
  if (isScrollNotAtBottom) {
    if (newMessageList.length >= 1) {
      const lastMessage = newMessageList[newMessageList.length - 1];
      if ((lastMessage as any).flow === 'out') {
        // 最新一条是自己发送的
        messageBottomEl.value.scrollTop = messageBottomEl.value.scrollHeight;
      }
    }
    return;
  }
  // 如果没进行滚动一直在底部, 直接展示最新消息
  messageBottomEl.value.scrollTop = messageBottomEl.value.scrollHeight;

});



const box = ref(null);
const getDom = () => {
      console.log('obx',box)
    };

let right=ref(false)
let left=ref(false)
function settimet(){
  right.value=!right.value
}
function    settimetzj(){
  left.value=!left.value
}

onMounted(() => {
  getScrollTop()
  window.addEventListener('scroll', handleMessageListScroll, true);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleMessageListScroll, true);
});

return { __sfc: true,chatStore, messageList, messageBottomEl, isScrollNotAtBottom, getScrollTop, handleMessageListScroll, timestampToTime, box, getDom, right, left, settimet, settimetzj, MessageText }
}

})